import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberWitoutRounding'
})
export class NumberWitoutRoundingPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    value = value.toString();
    if (value.indexOf(".") !== -1) {
      value = value.slice(0, (value.indexOf(".")) + 2);  
      return value;
    } else {
      return value;
    }
  }

}
